import React, { useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider, useSelector } from 'react-redux';

import { Flex, Loader } from '@homeexchange/design';
import { Sponsorship, setSponsorshipFetchConfig } from '@homeexchange/sponsorship';

import i18n from '../i18n';
import store from '../store';
import { getDynamicUrl } from '../middleware/lokaliseUrlMiddleware';
import { selectSession } from '../selectors/session';

const bffUrl = getDynamicUrl(process.env.URL_BFF);

setSponsorshipFetchConfig(bffUrl, {
    headers: {
        he_web_version: process.env.VERSION,
        'Accept-Language': i18n.language
    }
});

function toUserMe(user) {
    if (!user) {
        return undefined;
    }

    return {
        id: user.get('id'),
        locale: user.get('locale'),
        email: user.get('email'),
        first_name: user.get('first_name'),
        is_he_collection: Boolean(user.get('is_he_collection'))
    };
}

function SponsorshipApp() {
    const session = useSelector(selectSession);
    const user = useSelector((state) => state.user);
    const userMe = useMemo(() => toUserMe(user), [user]);

    const isSessionPending = session.status === 'loading' || (session.status === 'authenticated' && !userMe);

    if (isSessionPending) {
        return (
            <Flex justifyContent="center" alignItems="center" isFullWidth style={{ minHeight: '60vh' }}>
                <Loader />
            </Flex>
        );
    }

    return (
        <Sponsorship
            config={{
                apiUrl: bffUrl,
                locale: i18n.language,
                session,
                userMe,
                theme: document.documentElement.dataset.theme,
                facebookAppId: process.env.FACEBOOK_APP_ID
            }}
        />
    );
}

const page = document.getElementById('sponsorship-page');
if (page) {
    createRoot(page).render(
        <Provider store={store}>
            <SponsorshipApp />
        </Provider>
    );
}
